import type { OneTimeProduct, AssertProduct } from '@/store/products'

declare const _prd_RNRm5u6KKjPs: {
	id: 'prd_RNRm52DEV2u6KKjPs'
	ident: 'prd_RNRm5u6KKjPs'
	sku: 'simple_workbook_bundle_35_usd'
	type: 'one_time'
	price: {
		price_id: 'prc_xMUIW2DEV2aqECDgD'
		amount: 64
		amount_usd: 35
		currency: 'USD'
		amount_with_discount: 35
		discount: 29
		promocode: 'BASE'
	}
}
type _check = AssertProduct<typeof _prd_RNRm5u6KKjPs, OneTimeProduct>
const prd_RNRm5u6KKjPs = { ident: 'prd_RNRm5u6KKjPs' } as typeof _prd_RNRm5u6KKjPs

export default prd_RNRm5u6KKjPs
